import {Injectable} from '@angular/core';
import {ChatService} from './chat.service';
import {CompanyService} from './company.service';
import {DocTypeService} from './doc-type.service';
import {SickNoteService} from './sick-note.service';

/**
 * The submission funnel keeps the contact, the accepted terms, the chosen type,
 * the attached files and the company settings in root services, and its guards
 * let the next step through on them. A new sign-in starts a new funnel: on a
 * shared device the next person would otherwise submit with the previous
 * person's contact, so that person would receive the tracking link, and skip
 * the terms (DEV-1955).
 *
 * Nothing that matters is lost: the terms acceptance was recorded when it was
 * given, and the rest only leaves with a submission.
 */
@Injectable({providedIn: 'root'})
export class FunnelStateService {
  constructor(
    private chat: ChatService,
    private company: CompanyService,
    private docType: DocTypeService,
    private sickNote: SickNoteService
  ) {}

  reset(): void {
    this.chat.resetData();
    this.company.forgetSession();
    this.docType.selected = undefined;
    this.sickNote.reset();
  }
}
